import { useSelector } from 'react-redux'
import { updateClientSideUrl } from '../../helpers/url'
import { getHrefFunction } from 'connectors/Facets/helper'
import { BOOLEAN_FACETS_MAPPING_VALUE } from '../../helpers/constants'

type UseBooleanFacetParams = {
  facetName: string
  baseUrl: string
  nextAppRoute: string
}

export const useBooleanFacet = ({ facetName, baseUrl, nextAppRoute }: UseBooleanFacetParams) => {
  const getHref = useSelector(getHrefFunction)

  const changeUrlByBooleanFacet = (isInPathParam: boolean) => {
    const href = getHref({
      [facetName]: [isInPathParam ? BOOLEAN_FACETS_MAPPING_VALUE[facetName] : ''],
      page: '', // Reset Page
    })
    const newUrlPath = `${baseUrl}${href}`

    updateClientSideUrl(newUrlPath, nextAppRoute)
  }

  return { changeUrlByBooleanFacet }
}
